var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 60,
    viewBox: "0 0 152 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "h5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.76001 48.6386V39.8386L26.92 2.39859H39.96V38.8786H47V48.6386H39.96V59.9986H28.76V48.6386H0.76001ZM29.48 14.3986L13.08 38.8786H29.48V14.3986Z",
    fill: "#9FB6DB",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1306 30.0786C54.1306 20.8519 55.784 13.6253 59.0906 8.39859C62.4506 3.17193 67.9973 0.558594 75.7306 0.558594C83.464 0.558594 88.984 3.17193 92.2906 8.39859C95.6506 13.6253 97.3306 20.8519 97.3306 30.0786C97.3306 39.3586 95.6506 46.6386 92.2906 51.9186C88.984 57.1986 83.464 59.8386 75.7306 59.8386C67.9973 59.8386 62.4506 57.1986 59.0906 51.9186C55.784 46.6386 54.1306 39.3586 54.1306 30.0786ZM86.2906 30.0786C86.2906 26.1319 86.024 22.8253 85.4906 20.1586C85.0106 17.4386 83.9973 15.2253 82.4506 13.5186C80.9573 11.8119 78.7173 10.9586 75.7306 10.9586C72.744 10.9586 70.4773 11.8119 68.9306 13.5186C67.4373 15.2253 66.424 17.4386 65.8906 20.1586C65.4106 22.8253 65.1706 26.1319 65.1706 30.0786C65.1706 34.1319 65.4106 37.5453 65.8906 40.3186C66.3706 43.0386 67.384 45.2519 68.9306 46.9586C70.4773 48.6119 72.744 49.4386 75.7306 49.4386C78.7173 49.4386 80.984 48.6119 82.5306 46.9586C84.0773 45.2519 85.0906 43.0386 85.5706 40.3186C86.0506 37.5453 86.2906 34.1319 86.2906 30.0786Z",
    fill: "#9FB6DB",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.369 48.6386V39.8386L131.529 2.39859H144.569V38.8786H151.609V48.6386H144.569V59.9986H133.369V48.6386H105.369ZM134.089 14.3986L117.689 38.8786H134.089V14.3986Z",
    fill: "#9FB6DB",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.8223eb5e3ae20b64f3ad0ac828c81377.svg";
export { ForwardRef as ReactComponent };